import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import SVGInline from 'react-svg-inline';
import { connection } from '../../../Config/Settings'

// components
import {
    Date,
    Location,
    ButtonTickets,
    DescriptionBox,
    Instruments,
    Contact,
    Media,
    MediaTop
} from '../ModalElements';
import { RandomIcons } from '../../Elements/Decorations';

// consts
import { LIVE_MUSIC, SERVICE, BAND, MUSICIAN} from '../../../consts';

// svgs
import closeCrossSVG from '../../inlineSVGs/closeCrossSVG';
import fbShareWhiteSVG from '../../inlineSVGs/fbShareWhiteSVG';
import smallStarSVG from '../../inlineSVGs/smallStarSVG';
import scopWhiteTxtSVG from '../../inlineSVGs/scopWhiteTxtSVG';


// styles
import './PinFullViewModalWeb.css';
import {AnalyticsService} from "../../../Services";
import {formatMusicStyles, getIamACat} from "../../../utils";


// const MEDIA_REL_SIZE_WIDTH = 1.3;
// const MEDIA_REL_SIZE_HEIGHT = 1.3;

const PinFullViewModalWeb = ({ datatypes, pin, isModalOpen, closeModal }) => {
    // if (!pin) return null;

    const onFBShareClick = () => {
        // TODO: old implementation - FB moved away from this to doing its own crawling - TBR
        // const images = pin && pin.images ? pin.images.map((image) => {
        //     return {original: image.src, thumbnail: image.thumbnail};
        // }) : [];

        // const shareObject = {
        //     'og:url': `${connection().serverUrl}/pages?id=${pin._id}&ad=${pin._id}`,
        //     'og:title': pin.name,
        //     'og:description': pin.desc || 'Check this event on Mugics',
        //     'og:image': images[0] ? images[0].original : 'https://s3.amazonaws.com/mugics-events-images-new/img/logos/listen-logo.png',
        //     'og:image:url': images[0] ? images[0].original : 'https://s3.amazonaws.com/mugics-events-images-new/img/logos/listen-logo.png',
        // };
        //
        // window.FB.ui({
        //     method: 'share_open_graph',
        //     action_type: 'og.shares',
        //     action_properties: JSON.stringify({
        //         object : shareObject
        //     })
        // }, () => {});

        AnalyticsService.sendEvent(AnalyticsService.events.SHARE, [pin.name, 'ad_view_share'], null, {
            pin_type: pin.type,
            pin_category: pin.category
        });

        const url = `${connection().serverUrl}/pages?id=${pin._id}&ad=${pin._id}`;
        window.FB.ui({
            method: 'share',
            display: 'popup',
            href: url,
        }, function(res){});
    };

    // header by type color
    const renderHeader = text => {
        return <p className={`details-header ${pin.type}`}>{text}</p>
    };

    const handleDescScroll = val => {
    };

    const handleCloseModal = () => {
        if (window && window.history) {
            window.history.replaceState('', '', '/');
        }

        closeModal();
    };

    const calcMediaWidth = () => {
        // modal is 87% width
        const mainMediaWidth = (window.innerWidth * 0.95) * 0.55;

        // modal is 92% height
        // const mainMediaHeight = window.innerHeight * 0.92;

        return mainMediaWidth;

        // return mainMediaWidth && mainMediaWidth / MEDIA_REL_SIZE_WIDTH / (mainMediaWidth / mainMediaHeight);
    };

    const calcMediaHeight = () => {
        // modal is 80% width

        // const mainMediaWidth = window.innerWidth * 0.8;

        // modal is 92% height
        // const mainMediaHeight = window.innerHeight * 0.92;
        return calcMediaWidth() / 1.5;
        // return mainMediaHeight && mainMediaHeight / MEDIA_REL_SIZE_HEIGHT / (mainMediaWidth / mainMediaHeight);
    };

    const getMedia = () => {
        if (!pin) return [];

        const imagesUrl = pin.images.map(imgObj => imgObj.src);

        if (pin.video) {
            return [pin.video_embed, ...imagesUrl];
        }

        return [...imagesUrl];
    };

    const renderBandFinderType = () => {
        if (!pin || (pin.type !== BAND && pin.type !== MUSICIAN)) return null;

        const prefixText = pin.type === BAND ? 'אנחנו' : 'אני';
        const suffixText = pin.type === BAND ? '' : '';

        return (
            <div className={`band-finder-type ${pin.type}`}>
                {`${prefixText} ${getIamACat(pin.iWeAre, datatypes.categories[pin.type])} ${suffixText}`}
            </div>
        )
    };

    const renderBandFinderLookingFor = () => {
        if (!pin || (pin.type !== BAND && pin.type !== MUSICIAN)) return null;

        const isBand = pin.type === BAND;

        const topMargin = !pin.desc || pin.desc.length < 100 ? 'full' : '';

        const categories = datatypes.categories[isBand ? MUSICIAN : BAND];

        return (
            <div className={`band-finder-looking-for ${pin.type} ${topMargin}`}>
                <div className={`band-finder-icon-wrapper ${pin.type}`}>
                    <SVGInline className="band-finder-icon" svg={scopWhiteTxtSVG} component="i"/>
                </div>
                <p className="mini-header">בחיפוש אחרי:</p>
                {pin.lookingForTypes.map((t, i) => {

                    const cat = categories.find(c => c.name === t);

                    if (!cat || !cat.name) return null;

                    // each one looking for the opposite type
                    // const dataText = isBand ? cat.text.replace('player', '') : cat.text.replace('band', '');
                    // const suffixText = isBand ? '' : 'band';
                    return <div key={`looking-for-line-finder-modal-${i}`} className="looking-for-line">{`${cat.text}`}</div>
                })}
            </div>
        )
    };

    const getAboutHeader = () => {
        if (pin.type === LIVE_MUSIC) return 'show';
        if (pin.type === SERVICE) return 'business';
        if (pin.type === BAND) return 'artist';
        if (pin.type === MUSICIAN) return 'bans';

        return 'ad'
    }

    if (!pin) return null;

    return (
        <Modal
            isOpen={isModalOpen}
            contentLabel="Modal"
            className={`modal-outer-wrapper rtl`}
            style={{overlay: {
                    backgroundColor: 'rgba(16, 5, 23, 0.96)'
                }}}
        >
            <div className="close-button-container">
                <div onClick={() => handleCloseModal()} >
                    <SVGInline className="close-button" svg={closeCrossSVG} component="i"/>
                </div>
            </div>
            <div className={`modal-wrapper pin-full-view-modal ${pin.type}`}>
                <div className="content-wrapper">
                    <div className="info-wrapper">
                        <h2 className={`main-header ${pin.type}`} style={{width: window.innerWidth * 0.82}}>{pin.name}</h2>
                        {renderBandFinderType()}
                        {pin.date ? <Date date={pin.date} time={pin.time} wrapperStyle={{marginBottom: 5}} /> : null}
                        <Location
                            address={pin.location}
                            musicType={pin.category}
                        />

                        {pin.type === LIVE_MUSIC || pin.type === SERVICE ?
                            <ButtonTickets
                                label="לרכישת כרטיסים"
                                link={pin.ticketLink}
                                wrapperStyle={{marginTop: 20}}
                                prices={pin.prices}
                            /> : null
                        }

                        {renderBandFinderLookingFor()}

                        <div className="generic-wrapper desc-wrapper">
                            {pin.desc ? renderHeader(`פרטים`) : null}
                            <DescriptionBox text={pin.desc} onScroll={val => handleDescScroll(val)} />
                        </div>

                        {pin.type === LIVE_MUSIC ?
                            <div className="generic-wrapper instruments-wrapper">
                                {renderHeader('על הבמה:')}
                                <Instruments instruments={pin.instruments} />
                            </div>
                            : null
                        }

                        <div className="generic-wrapper contact-wrapper">
                            {pin.phone || pin.email || pin.link1 || pin.fblink ?
                                renderHeader('יצירת קשר')
                                : null
                            }
                            <Contact
                                type={pin.type}
                                info={{
                                    phone: pin.phone,
                                    email: pin.email,
                                    link: pin.link1,
                                    fblink: pin.fblink

                                }}
                            />
                        </div>
                        <div className="generic-wrapper share-wrapper" onClick={() => onFBShareClick()}>
                            {renderHeader('שיתוף')}
                            <SVGInline className="share-icon" svg={fbShareWhiteSVG} component="i"/>
                        </div>
                        <RandomIcons
                            isSmall
                            iconSVG={smallStarSVG}
                            opacity={0.3}
                            numIcons={20}
                            topLimit={100}
                            bottomLimit={window.innerHeight / 2}
                            leftLimit={50}
                            rightLimit={window.innerWidth / 4}
                        />
                    </div>
                    <div className="media-wrapper">
                        <div className="media-top" style={{width: calcMediaWidth()}}>
                            <MediaTop type={pin.type} styles={pin.subCategories} onShareClick={onFBShareClick} />
                        </div>
                        <Media
                            type={pin.type}
                            media={getMedia()}
                            mainMediaWidth={calcMediaWidth()}
                            mainMediaHeight={calcMediaHeight()}
                            vimeoThumbnailUrl={pin.video_thumbnail}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
};

PinFullViewModalWeb.propTypes = {
    pin: PropTypes.object,
    isModalOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    modalType: PropTypes.string,
    datatypes: PropTypes.object
};

PinFullViewModalWeb.defaultProps = {
    modalType: 'liveMusic'
};

export default PinFullViewModalWeb;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/PinFullViewModalWeb/PinFullViewModalWeb.js